import axios from "axios";
import { server } from "../../server"; 

export const createChildColor = (name, parents, images) => async (dispatch) => {
  try {
    dispatch({ type: "createChildColorRequest" });

    const { data } = await axios.post(
      `${server}/color/create-color`,
      { name, parents, images },
      { withCredentials: true }
    );

    dispatch({
      type: "createChildColorSuccess",
      payload: data.color, 
    });
  } catch (error) {
    dispatch({
      type: "createChildColorFail",
      payload:
        error.response?.data?.message || error.message || "Create child color error",
    });
  }
};

export const getAllChildColors = () => async (dispatch) => {
  try {
    dispatch({ type: "getAllChildColorsRequest" });
    const { data } = await axios.get(`${server}/color/get-all-colors`, {
      withCredentials: true,
    });

    dispatch({
      type: "getAllChildColorsSuccess",
      payload: data.colors, 
    });
  } catch (error) {
    dispatch({
      type: "getAllChildColorsFail",
      payload:
        error.response?.data?.message || error.message || "Fetch child colors error",
    });
  }
};

export const getOneChildColor = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getOneChildColorRequest" });

    const { data } = await axios.get(`${server}/color/get-color/${id}`, {
      withCredentials: true,
    });

    dispatch({
      type: "getOneChildColorSuccess",
      payload: data.color, 
    });
  } catch (error) {
    dispatch({
      type: "getOneChildColorFail",
      payload:
        error.response?.data?.message || error.message || "Get child color error",
    });
  }
};

export const updateChildColor =
  (id, { name, parents, imagesToDelete, newImages }) =>
  async (dispatch) => {
    try {
      dispatch({ type: "updateChildColorRequest" });
      const { data } = await axios.put(
        `${server}/color/update-color/${id}`,
        {
          name,
          parents,
          imagesToDelete, 
          newImages,
        },
        { withCredentials: true }
      );

      dispatch({
        type: "updateChildColorSuccess",
        payload: data.color, 
      });
    } catch (error) {
      dispatch({
        type: "updateChildColorFail",
        payload:
          error.response?.data?.message || error.message || "Update child color error",
      });
    }
  };

export const deleteChildColor = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteChildColorRequest" });

    const { data } = await axios.delete(`${server}/color/delete-color/${id}`, {
      withCredentials: true,
    });

    dispatch({
      type: "deleteChildColorSuccess",
      payload: data.message, 
    });
  } catch (error) {
    dispatch({
      type: "deleteChildColorFail",
      payload:
        error.response?.data?.message || error.message || "Delete child color error",
    });
  }
};

export const clearErrors = () => async (dispatch) => {
  dispatch({ type: "clearErrors" });
};
